export const REGION_LIST = ['Africa', 'Asia', 'Europe', 'Latin America and the Caribbean', 'North America', 'Oceania'];

export const REGION_PARAM = 'region'; // encodes to 'region'

export const GDPR_REGIONS = {
  EU: 'eu',
  US: 'us',
  AU: 'au',
  GLOBAL: 'global'
};
